import { BaseQueryFn, EndpointBuilder, FetchArgs, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { Permission, PermissionByModule, ResponseList } from "types";
import apiRoutes from "../apiRoutes";

export const permissionApi = (builder: EndpointBuilder<BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>, string, "api">) => ({
    getPermissions: builder.query<ResponseList<PermissionByModule>, void>({
        query: () => apiRoutes.getPermission,
    }),
})